export default {
      count: 0,
      list: [],
      project: {},
      contacts: [{}]
    }
